import { render, staticRenderFns } from "./Newspaper.vue?vue&type=template&id=ac1e935c&scoped=true&"
import script from "./Newspaper.vue?vue&type=script&lang=js&"
export * from "./Newspaper.vue?vue&type=script&lang=js&"
import style0 from "./Newspaper.vue?vue&type=style&index=0&id=ac1e935c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1e935c",
  null
  
)

export default component.exports